import { Navigate, useLocation } from "react-router";

export const CmsRedirectToBannerTab = () => (
  <Navigate to="/banner" replace />
);

export const CmsRedirectToPagesTab = () => (
  <Navigate to="/cms-management?tab=pages" replace />
);

export const CmsRedirectToFaqTab = () => (
  <Navigate to="/cms-management?tab=faq" replace />
);

export const CmsRedirectToTrainingTab = () => (
  <Navigate to="/cms-management?tab=training" replace />
);

export const CmsRedirectToSmsTemplatesTab = () => (
  <Navigate to="/cms-management?tab=sms-templates" replace />
);

export const CmsRedirectToEmailTemplatesTab = () => (
  <Navigate to="/cms-management?tab=email-templates" replace />
);

export const CmsRedirectToNotificationTemplatesTab = () => (
  <Navigate to="/cms-management?tab=notification-templates" replace />
);

export const CmsRedirectToContactEnquiryTab = () => (
  <Navigate to="/contact-enquiry" replace />
);

export const CmsRedirectToReportIssueTab = () => {
  const { search } = useLocation();
  const incoming = new URLSearchParams(search);
  const next = new URLSearchParams({ tab: "report-issue" });
  const type = incoming.get("type");
  if (type) next.set("type", type);
  return <Navigate to={`/cms-management?${next.toString()}`} replace />;
};

export const CmsRedirectToTripCancelManagerTab = () => (
  <Navigate to="/cms-management?tab=trip-cancel-manager" replace />
);

export const CmsRedirectToPromoCodeTab = () => (
  <Navigate to="/cms-management?tab=promo-code" replace />
);

export const CmsRedirectToStateManagementTab = () => (
  <Navigate to="/cms-management?tab=state-management" replace />
);
